<template>
  <VApp>
    <VContent>
      <VContainer
        fluid
        fill-height
      >
        <VLayout
          align-center
          justify-center
        >
          <VFlex
            md4
            sm8
            xs12
          >
            <PhoneVerificationRequestCard />
          </VFlex>
        </VLayout>
      </VContainer>
    </VContent>
  </VApp>
</template>

<script>
import PhoneVerificationRequestCard from '@/components/PhoneVerificationRequestCard'
export default {
  name: 'PhoneVerificationRequestPage',
  components: {
    PhoneVerificationRequestCard
  }
}
</script>

<style scoped>

</style>
